import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';

export const sawTutorialMiddleware = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
) => {
    if (
        (to.meta.hasOwnProperty('public') && to.meta.public) ||
        to.name === 'tutorial'
    ) {
        next()
    } else {
        const sawTutorial = localStorage.getItem('sawTutorial') === 'true' || false
        if (!sawTutorial) {
            next({name: 'tutorial'})
        } else {
            next()
        }
    }
}